// extracted by mini-css-extract-plugin
module.exports = {"msgWarning":"AddressFieldAlertContent_msgWarning__vLmCk"};